import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'boolean',
})
export class BooleanPipe implements PipeTransform {
    transform(value?: any, invert?: boolean): boolean {
        const bool = Boolean(value);
        return invert ? !bool : bool;
    }
}
